export default {"src":"/_next/static/media/grid-gray.497147fa.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};